module.exports = __webpack_public_path__ + "static/media/jtoperationshead.ab9c2840.jpg";